import { useEffect } from "react";
import { useGroups } from "../../api/hooks/groups";
import GroupItem from "./GroupItem";
import styles from "./Groups.module.css";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowRightIcon from "../Icon/ArrowRightIcon";

const Groups: React.FC<{
  label?: string;
  initialGroups?: any[] | false;
  labelColor?: string;
  labelSize?: number;
  filter?: false | any;
  gameId?: string;
}> = ({
  label = "label",
  labelColor = "#000",
  initialGroups = false,
  labelSize = 18,
  filter = false,
  gameId,
}) => {
  const { groups, fetchGroups } = useGroups();
  const { t } = useTranslation();
  // Re-fetch on the filter's CONTENT, not its object identity. Callers such as
  // BetWrapper and GroupDetail pass a fresh `{ game: gameId }` literal every render,
  // so depending on `filter` directly would refetch on every render; depending on
  // nothing (`[]`) leaves the list stale when the game changes in place (route param
  // swap with no remount). Serializing to a stable string re-fires only when the
  // filter content actually changes and never loops on identical content.
  const filterKey = filter ? JSON.stringify(filter) : "";
  useEffect(() => {
    if (!initialGroups) {
      fetchGroups(filter);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- keyed on serialized filter content (filterKey); fetchGroups identity is unstable and not a trigger
  }, [filterKey, initialGroups]);
  return (
    <div className={styles.GroupsWrapper}>
      <div className={styles.GroupsHeader}>
        <span
          className={styles.GroupsTitle}
          style={{ color: labelColor, fontSize: labelSize }}
        >
          {label}
        </span>
      </div>
      <div className={styles.GroupsList}>
        {(!!initialGroups ? initialGroups : groups).map(
          (item: any, index: number) => (
            <GroupItem groupInfo={item} key={index} />
          )
        )}
        <div className={styles.GroupsFooter}>
          <RouterLink
            to="/groups"
            state={gameId ? { gameFilter: gameId } : undefined}
            style={{ display: "flex", alignItems: "center", gap: 4, color: "inherit", textDecoration: "none", fontWeight: 600 }}
          >
            {t("groups.all")}
            <ArrowRightIcon size="14px" />
          </RouterLink>
        </div>
      </div>
    </div>
  );
};

export default Groups;
